import { lazy } from "react";
import type { RouteObject, UIMatch } from "react-router";

import { ModuleBreadcrumb } from "./ModuleBreadcrumb.tsx";

export const moduleRoute: RouteObject = {
  path: "/modules/:moduleId",
  handle: {
    // See useRouterBreadcrumbs() in nautilus-core-designer
    getBreadcrumbTitle: (match: UIMatch, isLast: boolean) => {
      return <ModuleBreadcrumb id={match.params.moduleId!} isLast={isLast} />;
    },
  },
  // Break out the actual component rendering to a child route with both index and all child paths.
  // This lets us match all module paths with the same component, but still have the matched pathname be the top
  // level module path for the breadcrumb.
  children: [
    {
      index: true,
      path: "*",
      Component: lazy(async () => {
        const { ModulePage } = await import("./ModulePage");
        return { default: ModulePage };
      }),
    },
  ],
};
